export default __webpack_public_path__ + "assets/images/def062c5d8cccea1b5562028ceebfe2d.svg";